import * as nopimsRouteHelper from "./nopims/routeHelper";

// facade for all route helpers

const routeHelpers = {
    nopims: nopimsRouteHelper,
};

export default routeHelpers;
